import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
    getUnibaServiziOnline,
    getUnibaHeaderSlimConfig,
    getUnibaShowServiziOnline
} from 'design-comuni-plone-theme/actions';
import { HeaderSlimListItemUniba } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { getViewName } from 'design-comuni-plone-theme/components';
import HeaderSlimListUnibaSkeleton from './HeaderSlimListUnibaSkeleton';

class HeaderSlimListUniba extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviziOnlineElement: null
        };
    };

    componentDidMount() {
        this.props.getUnibaServiziOnline();
        this.props.getUnibaHeaderSlimConfig();
        this.props.getUnibaShowServiziOnline();
    };

    componentDidUpdate(prevProps) {
        const {
            serviziOnlineResult,
            serviziOnlineLoading,
            showServiziOnlineResult,
            intl,
        } = this.props;

        if (
            showServiziOnlineResult === true &&
            serviziOnlineLoading === false &&
            serviziOnlineResult &&
            !this.state.serviziOnlineElement
        ) {
            if ('url' in serviziOnlineResult) {
                const serviziOnlineEndpoint = getViewName(serviziOnlineResult.url);
                this.setState({
                    serviziOnlineElement: (
                        <HeaderSlimListItemUniba
                            staticLink={false}
                            href="https://www.uniba.it/servizionline"
                            endpoint={`/${serviziOnlineEndpoint}`}
                            title={intl.formatMessage({
                                id: 'servizi_online_title',
                                defaultMessage: 'Servizi Online',
                            })}
                        />
                    ),
                });
            } else if ('content' in serviziOnlineResult) {
                this.setState({
                    serviziOnlineElement: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: serviziOnlineResult.content,
                            }}
                        />
                    ),
                });
            } else {
                this.setState({ serviziOnlineElement: null });
            }
        }
    };

    render() {
        const {
            headerConfigResult,
            intl,

            serviziOnlineLoading,
            headerConfigLoading,
            showServiziOnlineLoading,

        } = this.props;
        const locale = intl.locale;
        const { serviziOnlineElement } = this.state;

        const isLoading =
            serviziOnlineLoading ||
            headerConfigLoading ||
            showServiziOnlineLoading ||
            !serviziOnlineElement;
            
        if (isLoading) {
            return <HeaderSlimListUnibaSkeleton />;
        }
        return (
            <ul
                className="uniba-topbar__list"
                id="topbar-list"
                role="menubar"
                aria-label="Navigazione principale"
            >
                {serviziOnlineElement}
                {headerConfigResult?.items &&
                    headerConfigResult.items.map((item) => {
                        if (!item.abilitato) return null;

                        const title = intl.formatMessage({
                            id: item.title_id,
                            defaultMessage:
                                locale === 'it' ? item.title_id : item.title_en,
                        });

                        return (
                            <HeaderSlimListItemUniba
                                key={item['@id']}
                                staticLink={item.statico}
                                href={item.link_statico}
                                endpoint={item.link_endpoint}
                                title={title}
                                dropdown_json={item.json ? JSON.parse(item.json) : ''}
                            />
                        );
                    })}
            </ul>
        );
    };
}

HeaderSlimListUniba.propTypes = {
    serviziOnlineResult: PropTypes.object,
    serviziOnlineLoading: PropTypes.bool,

    headerConfigResult: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.object),
    }),
    headerConfigLoading: PropTypes.bool,

    showServiziOnlineResult: PropTypes.bool,
    showServiziOnlineLoading: PropTypes.bool,

    getUnibaServiziOnline: PropTypes.func.isRequired,
    getUnibaHeaderSlimConfig: PropTypes.func.isRequired,
    getUnibaShowServiziOnline: PropTypes.func.isRequired,

    intl: PropTypes.object.isRequired,
};

export default connect(
    (state) => ({
        serviziOnlineResult: state.unibaServiziOnline?.result,
        serviziOnlineLoading: state.unibaServiziOnline?.loadingResults,

        headerConfigResult: state.unibaHeaderSlimConfig?.result,
        headerConfigLoading: state.unibaHeaderSlimConfig?.loadingResults,

        showServiziOnlineResult:
            typeof state.unibaShowServiziOnline.result === 'boolean'
                ? state.unibaShowServiziOnline.result
                : undefined,
        showServiziOnlineLoading: state.unibaShowServiziOnline?.loadingResults,
    }),
    {
        getUnibaServiziOnline,
        getUnibaHeaderSlimConfig,
        getUnibaShowServiziOnline,
    }
)(injectIntl(HeaderSlimListUniba));
